module.exports = __webpack_public_path__ + "img/DE03739.0332cf8d.svg";